// extracted by mini-css-extract-plugin
module.exports = {"HyperLink_Wrapper":"DownloadFile_HyperLink_Wrapper__3twv3"};